import { SxProps, Theme } from "@mui/material";

// Shared table header-cell style for the payroll (employees / salaries) tables.
// Matches the house style used across the system (e.g. branches table).
export const salaryHeadCellSx: SxProps<Theme> = {
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "18px",
  color: "#475467",
  bgcolor: "#F9FAFB",
  whiteSpace: "nowrap",
};
